import React, { useState } from "react";
import { Badge, Tab, Nav, NavItem } from "react-bootstrap";
import Chart from "react-apexcharts";
import OptionResults from "./OptionResults";
import { generateColor } from "../libs/colors";
import "./Results.css";

export default function Results({
  poll,
  respData,
  isRaw,
  width
}) {
  const [filter, setFilter] = useState(isRaw ? 'raw' : 'weighted');

  const dem_targ = .38;
  const rep_targ = .30;
  const ind_targ = .28;
  const oth_targ = .04;

  let dem_weight = 0;
  let rep_weight = 0;
  let ind_weight = 0;
  let oth_weight = 0;
  let total_weighted_votes = 0;

  let weighted = filter === 'weighted';

  if (poll.demos) {
    total_weighted_votes = poll.demos.party.democrat + poll.demos.party.republican + 
      poll.demos.party['lean-democrat'] + poll.demos.party['lean-republican'] + 
      poll.demos.party.independent + poll.demos.party.other;

    const dem_samp = (poll.demos.party['lean-democrat'] + poll.demos.party.democrat) / total_weighted_votes;
    const rep_samp = (poll.demos.party['lean-republican'] + poll.demos.party.republican) / total_weighted_votes;
    const ind_samp = poll.demos.party.independent / total_weighted_votes;
    const oth_samp = poll.demos.party.other / total_weighted_votes;

    dem_weight = dem_samp ? (dem_targ / dem_samp) : 0;
    rep_weight = rep_samp ? (rep_targ / rep_samp) : 0;
    ind_weight = ind_samp ? (ind_targ / ind_samp) : 0;
    oth_weight = oth_samp ? (oth_targ / oth_samp) : 0;
    //console.log(dem_weight, rep_weight, ind_weight, oth_weight)

    if (total_weighted_votes < 100 || dem_weight * rep_weight * ind_weight * oth_weight === 0)
      weighted = false;
  } else {
    weighted = false;
  }

  if (poll.series_data && (filter === 'raw' || filter === 'weighted' )) {
    let labels = [];
    let approve_data = [];
    let disapprove_data = [];
    poll.series_data.forEach(data => {
      // compute weights
      let dem_weight = 0;
      let rep_weight = 0;
      let ind_weight = 0;
      let oth_weight = 0;
      let total_weighted_votes = 0;

      let weighted = filter === 'weighted';

      if (data.poll.demos) {
        total_weighted_votes = data.poll.demos.party.democrat + data.poll.demos.party.republican + 
          data.poll.demos.party['lean-democrat'] + data.poll.demos.party['lean-republican'] + 
          data.poll.demos.party.independent + data.poll.demos.party.other;

        const dem_samp = (data.poll.demos.party['lean-democrat'] + data.poll.demos.party.democrat) / total_weighted_votes;
        const rep_samp = (data.poll.demos.party['lean-republican'] + data.poll.demos.party.republican) / total_weighted_votes;
        const ind_samp = data.poll.demos.party.independent / total_weighted_votes;
        const oth_samp = data.poll.demos.party.other / total_weighted_votes;

        dem_weight = dem_samp ? (dem_targ / dem_samp) : 0;
        rep_weight = rep_samp ? (rep_targ / rep_samp) : 0;
        ind_weight = ind_samp ? (ind_targ / ind_samp) : 0;
        oth_weight = oth_samp ? (oth_targ / oth_samp) : 0;

        if (total_weighted_votes < 100 || dem_weight * rep_weight * ind_weight * oth_weight === 0)
          weighted = false;
      } else {
        weighted = false;
      }

      // approve pct
      let approve_pct;
      let opt = data.poll.questions[0].options[0];
      if (opt.tally === 0 || data.poll.votes === 0)
        approve_pct = 0;
      else if (opt.tally === data.poll.votes)
        approve_pct = 100;
      else if (filter === 'raw' || (filter === 'weighted' && !weighted)) // raw
        approve_pct = opt.tally/data.poll.votes*100;
      else { // weighted
        const dem_opt = (opt.demos.party['lean-democrat'] + opt.demos.party.democrat) * dem_weight;
        const rep_opt = (opt.demos.party['lean-republican'] + opt.demos.party.republican) * rep_weight;
        const ind_opt = opt.demos.party.independent * ind_weight;
        const oth_opt = opt.demos.party.other * oth_weight;
        approve_pct = (dem_opt + rep_opt + ind_opt + oth_opt)/total_weighted_votes*100;
      }

      // disapprove pct
      let disapprove_pct;
      opt = data.poll.questions[0].options[1];
      if (opt.tally === 0 || data.poll.votes === 0)
        disapprove_pct = 0;
      else if (opt.tally === data.poll.votes)
        disapprove_pct = 100;
      else if (filter === 'raw' || (filter === 'weighted' && !weighted)) // raw
        disapprove_pct = opt.tally/data.poll.votes*100;
      else { // weighted
        const dem_opt = (opt.demos.party['lean-democrat'] + opt.demos.party.democrat) * dem_weight;
        const rep_opt = (opt.demos.party['lean-republican'] + opt.demos.party.republican) * rep_weight;
        const ind_opt = opt.demos.party.independent * ind_weight;
        const oth_opt = opt.demos.party.other * oth_weight;
        disapprove_pct = (dem_opt + rep_opt + ind_opt + oth_opt)/total_weighted_votes*100;
      }

      labels.push(data.label);
      approve_data.push(approve_pct);
      disapprove_data.push(-disapprove_pct);
    });
    const series = [
      {
        name: "Approve",
        data: approve_data,
      },
      {
        name: "Disapprove",
        data: disapprove_data,
      },
    ];
    const options = {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      colors: ["#009f29", "#ff7400"],
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "70%",
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        padding: {
          top: 0,
          right: 70,
          bottom: 0,
          left: 70
        }, 
      },
      tooltip: {
        enabled: false
      },
      states: {
        hover: {
          filter: {
            type: 'none',
          }
        },
      },
      xaxis: {
        categories: labels,
        labels: {
          formatter: function (val) {
            return Math.abs(Math.round(val)) + "%";
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            fontSize: "14px",
            fontWeight: "bold",
          },
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "16px",
          fontWeight: "bold",
          colors: ["#FFF"],
        },
        formatter: function (val, opt) {
          return (
            Math.abs(val).toFixed(1) + "%"
          );
        },
        offsetY: -2
      },
      legend: { show: false },
      annotations: {
        xaxis: [{
          x: 30,
          borderColor: 'rgba(0,0,0,0.0)',
          label: {
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#009f29',
            },
            text: 'Approve',
            position: 'bottom',
            orientation: 'horizontal',
            offsetY: 3,
          }
        },{
          x: -30,
          borderColor: 'rgba(0,0,0,0.0)',
          label: {
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#ff7400',
            },
            text: 'Disapprove',
            position: 'bottom',
            orientation: 'horizontal',
            offsetY: 3,
          }
        }],
      }
    };
    return (
        <Chart
          options={options}
          series={series}
          type="bar"
          height={60*poll.series_data.length}
        />
    );
  }
  
  const filters = 
    {
      party: {
        name: 'party',
        title: 'Party',
        values: [
          "Democrat",
          "Republican",
          "Independent",
          "Other"
        ],
        colors: ["#11a0e9", "#f44042", "#22d263", "#fa7319"]
      },
      gender: {
        name: 'gender',
        title: 'Gender',
        values: ['Male', 'Female', 'Other'],
        colors: generateColor("#FFA401", "#DA00D6", 3)
      },
      race: {
        name: 'race',
        title: 'Race',
        values: [
          "White", 
          "Asian", 
          "Black",
          "Hispanic",
          "Native",
          "Other"
        ],
        colors: generateColor("#FFA401", "#DA00D6", 6)
      },
      age: {
        name: 'age',
        title: 'Age',
        values: [
          "< 18",
          "18 - 34",
          "35 - 49",
          "50 - 64",
          "65 +"
        ],
        colors: generateColor("#FFA401", "#DA00D6", 5)
      },
      region: {
        name: 'region',
        title: 'Region',
        values: [
          "Northeast",
          "West",
          "Midwest",
          "South"
        ],
        colors: generateColor("#FFA401", "#DA00D6", 4)
      },
      education: {
        name: 'education',
        title: 'Education',
        values: [
          "Less than a Bachelor's Degree",
          "Bachelor's Degree or Higher"
        ],
        colors: generateColor("#FFA401", "#DA00D6", 2)
      },
      raw: {
        values: []
      },
      weighted: {
        values: []
      }
    }
  
  return (
    <div style={{marginTop: '10px', display: 'flex', flexDirection: 'column'}}>
    <Tab.Container
      activeKey={filter}
      onSelect={key => setFilter(key)}
      style={{margin: '0 auto 4px', width: width !== 'xl' ? '80%' : 'fit-content'}}
      animation={false}
      id="tabs"
    >
      <Nav bsStyle="pills">
        <NavItem eventKey={"raw"} title="Raw">Raw</NavItem>
        { poll.votes >= 100 && <NavItem eventKey={"weighted"} title="Weighted">Weighted</NavItem> }
        { poll.demos /*&& !poll.series_id*/ &&
          Object.keys(filters).map((key, idx) => {
            const filter = filters[key];
            if (filter.values.length === 0) return null;
            if (filter.name === 'region' && !poll.demos.region) return null;
            return (
              <NavItem key={idx} eventKey={filter.name} title={filter.title}>
                {filter.title}
              </NavItem>
            );
          })
        }
      </Nav>
    </Tab.Container>
    <div className="legends">
      {
        filter ? filters[filter].values.map((value, idx) => (
          <span key={idx} className="legend">
            <Badge style={{backgroundColor: filters[filter].colors[idx]}} className="legend-badge">&nbsp;</Badge>
            <span className='legend-text'>{value}</span>
          </span>
        )) : null
      }
    </div>
    {poll.questions.map((ques, qidx) => {
      let resp_idx = -1;
      if (respData.responses) { // get index of user's response option (logged in)
        const resp_opt = respData.responses[ques.question_id];
        resp_idx = ques.options.map((opt) => opt.option_id).indexOf(resp_opt);
        if (resp_idx === -1)
          resp_idx = ques.options.map((opt) => opt.value).indexOf(resp_opt);
      }
      if (respData.ans) { // get index of user's response option (logged out)
        resp_idx = ques.options.map((opt) => opt.option_id).indexOf(respData.ans);
        if (resp_idx === -1)
          resp_idx = ques.options.map((opt) => opt.value).indexOf(respData.ans);
      }
      return (
        <div key={qidx} style={{marginBottom: "8px"}}>
          <div style={{marginBottom: "14px", display: 'flex'}}>
            <h4 className="question-num">{"Q" + (qidx+1)}</h4>
            <h4 className="question-text">{ ques.question_text }</h4>
          </div>
          <div className="results">
            {
              ques.options.map((opt, oidx) => {
                let pct, color, voted;
                voted = false;

                if (oidx === resp_idx) {
                  color = "#fa7319";
                  voted = true;
                }
                else
                  color = '#fcc17d';
                
                if (opt.tally === 0 || poll.votes === 0)
                  pct = '0';
                else if (opt.tally === poll.votes)
                  pct = '100';
                else if (filter === 'raw' || (filter === 'weighted' && !weighted)) // raw
                  pct = parseFloat(opt.tally/poll.votes*100).toFixed(1);
                else if (filter === 'weighted' && weighted) { // weighted
                  const dem_opt = (opt.demos.party['lean-democrat'] + opt.demos.party.democrat) * dem_weight;
                  const rep_opt = (opt.demos.party['lean-republican'] + opt.demos.party.republican) * rep_weight;
                  const ind_opt = opt.demos.party.independent * ind_weight;
                  const oth_opt = opt.demos.party.other * oth_weight;
                  pct = parseFloat((dem_opt + rep_opt + ind_opt + oth_opt)/total_weighted_votes*100).toFixed(1)
                } else { // filter
                  if (filter === 'party') {
                    pct = [
                      poll.demos.party['lean-democrat'] + poll.demos.party.democrat ? 
                        parseFloat((opt.demos.party['lean-democrat'] + opt.demos.party.democrat)/
                        (poll.demos.party['lean-democrat'] + poll.demos.party.democrat)*100).toFixed(1) : 0,
                      poll.demos.party['lean-republican'] + poll.demos.party.republican ? 
                        parseFloat((opt.demos.party['lean-republican'] + opt.demos.party.republican)/
                        (poll.demos.party['lean-republican'] + poll.demos.party.republican)*100).toFixed(1) : 0,
                      poll.demos.party.independent ? 
                        parseFloat(opt.demos.party.independent/poll.demos.party.independent*100).toFixed(1) : 0,
                      poll.demos.party.other ? 
                        parseFloat(opt.demos.party.other/poll.demos.party.other*100).toFixed(1) : 0
                    ];
                    color = ["#11a0e9", "#f44042", "#22d263", "#fa7319"];
                  } else if (filter === 'gender') {
                    pct = [
                      poll.demos.gender.male ? 
                        parseFloat(opt.demos.gender.male/poll.demos.gender.male*100).toFixed(1) : 0,
                      poll.demos.gender.female ? 
                        parseFloat(opt.demos.gender.female/poll.demos.gender.female*100).toFixed(1) : 0,
                      poll.demos.gender.other ? 
                        parseFloat(opt.demos.gender.other/poll.demos.gender.other*100).toFixed(1) : 0
                    ];
                    color = generateColor("#FFA401","#DA00D6",3);
                  } else if (filter === 'race') {
                    pct = [
                      poll.demos.race.white ? 
                        parseFloat(opt.demos.race.white/poll.demos.race.white*100).toFixed(1) : 0,
                      poll.demos.race.asian ? 
                        parseFloat(opt.demos.race.asian/poll.demos.race.asian*100).toFixed(1) : 0,
                      poll.demos.race.black ? 
                        parseFloat(opt.demos.race.black/poll.demos.race.black*100).toFixed(1) : 0,
                      poll.demos.race.hispanic ? 
                        parseFloat(opt.demos.race.hispanic/poll.demos.race.hispanic*100).toFixed(1) : 0,
                      poll.demos.race.nativeamerican ? 
                        parseFloat(opt.demos.race.nativeamerican/poll.demos.race.nativeamerican*100).toFixed(1) : 0,
                      poll.demos.race.other ? 
                        parseFloat(opt.demos.race.other/poll.demos.race.other*100).toFixed(1) : 0
                    ];
                    color = generateColor("#FFA401","#DA00D6",6);
                  } else if (filter === 'age') {
                    pct = [
                      poll.demos.age['<18'] ? 
                        parseFloat(opt.demos.age['<18']/poll.demos.age['<18']*100).toFixed(1) : 0,
                      poll.demos.age['18-34'] ? 
                        parseFloat(opt.demos.age['18-34']/poll.demos.age['18-34']*100).toFixed(1) : 0,
                      poll.demos.age['35-49'] ? 
                        parseFloat(opt.demos.age['35-49']/poll.demos.age['35-49']*100).toFixed(1) : 0,
                      poll.demos.age['50-64'] ? 
                        parseFloat(opt.demos.age['50-64']/poll.demos.age['50-64']*100).toFixed(1) : 0,
                      poll.demos.age['65+'] ? 
                        parseFloat(opt.demos.age['65+']/poll.demos.age['65+']*100).toFixed(1) : 0
                    ];
                    color = generateColor("#FFA401","#DA00D6",5);
                  }  else if (filter === 'region') {
                    pct = [
                      poll.demos.region['Northeast'] ? 
                        parseFloat(opt.demos.region['Northeast']/poll.demos.region['Northeast']*100).toFixed(1) : 0,
                      poll.demos.region['West'] ? 
                        parseFloat(opt.demos.region['West']/poll.demos.region['West']*100).toFixed(1) : 0,
                      poll.demos.region['Midwest'] ? 
                        parseFloat(opt.demos.region['Midwest']/poll.demos.region['Midwest']*100).toFixed(1) : 0,
                      poll.demos.region['South'] ? 
                        parseFloat(opt.demos.region['South']/poll.demos.region['South']*100).toFixed(1) : 0
                    ];
                    color = generateColor("#FFA401","#DA00D6",4);
                  } else if (filter === 'education') {
                    pct = [
                      poll.demos.education.highschool ? 
                      parseFloat(opt.demos.education.highschool/poll.demos.education.highschool*100).toFixed(1) : 0,
                      poll.demos.education.bachelors ? 
                        parseFloat(opt.demos.education.bachelors/poll.demos.education.bachelors*100).toFixed(1) : 0,
                    ];
                    color = generateColor("#FFA401","#DA00D6",2);
                  }
                }

                return (
                  <OptionResults
                    key={ oidx }
                    optionText={ opt.value }
                    optionPct={ pct }
                    isStriped={ false }
                    animateLoad={ true }
                    color={ color }
                    voted={ voted }
                    filter={filter}
                  />
                )
              })
            }
          </div>
        </div>
      )
    })}
    </div>
  );
}
